export const STICKY_ANCHOR_DATA_NAME = 'data-sticky-title'
export const STICKY_NAVIGATION_SCROLL_CONTAINER_NAME = 'sticky-navigation-scroll-container'
